var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.featuredProjectCategoriesEnabled
        ? _c(
            "heading-with-icon",
            {
              staticClass: "_pb-1",
              attrs: { tag: "h2", "icon-name": "fire", "icon-namespace": "ga" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.Resources.Homepage.FeaturedSectionTitle) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-slider", {
        attrs: {
          items: _vm.slides,
          "extra-large-screen-visible-items-count": 1,
          "large-screen-visible-items-count": 1,
          tags: _vm.tags,
          "default-tag-key": _vm.currentTagKey,
          "slide-gap-classes": "_px-2 _px-3--m",
          "scroll-container-wrapper-classes": "_pos-r _-mt-2 _-mx-2 _-mx-3--m",
          "navigation-wrapper-classes": "_shrink-0",
          "is-processing": _vm.isProcessing,
        },
        on: {
          "tag-clicked": _vm.onTagClicked,
          "scroll-left": function ($event) {
            return _vm.onScroll("left")
          },
          "scroll-right": function ($event) {
            return _vm.onScroll("right")
          },
          "view-all": _vm.onViewAll,
          "get-items": _vm.getPromotedProjects,
        },
        scopedSlots: _vm._u([
          {
            key: "prefix",
            fn: function () {
              return [
                !_vm.featuredProjectCategoriesEnabled
                  ? _c(
                      "heading-with-icon",
                      {
                        staticClass: "_pb-1",
                        attrs: {
                          tag: "h2",
                          "icon-name": "fire",
                          "icon-namespace": "ga",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.Resources.Homepage.FeaturedSectionTitle
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "placeholder",
            fn: function () {
              return [_c("skeleton-featured-slide")]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }